import { useNavigate } from "react-router-dom";

import { Deal } from "@Types/deal";
import Grid from "@Components/Grid";
import Paper from "@Components/Paper";
import Button from "@Components/Button";
import { formatDate } from "@Utils/functions";
import { getDmvStatus } from "@Types/title_issues";
import { renderFieldData } from "@Components/FieldData/RenderFieldData";

import styles from "./TitleInfo.module.scss";
import { getNextCheckDate } from "../Applications";

const TitleInfo = ({ deal }: { deal: Deal }) => {
  const navigate = useNavigate();

  const titleIssue = deal?.data?.titleIssue;
  const openTitle = () => {
    if (titleIssue) navigate(`/title_info/${titleIssue._id}`);
  };
  const info = titleIssue?.data?.info;

  const status = getDmvStatus(info?.dmvInfo?.status);

  return (
    <Paper title="Title Information">
      <Grid container xs={12}>
        <Grid xs={12}>
          {renderFieldData("Status", status, {
            ...statusStyles.base,
            ...(status === "Titled"
              ? statusStyles.statusTitled
              : status === "Untitled"
              ? statusStyles.statusUntitled
              : statusStyles.statusNotChecked),
          })}
        </Grid>

        <Grid xs={12}>
          {renderFieldData(
            "Last checked date",
            info?.lastCheckedDate ? formatDate(info?.lastCheckedDate) : "N/A"
          )}
        </Grid>
        {status !== "Titled" && (
          <Grid xs={12}>
            {renderFieldData(
              "Next check date",
              titleIssue ? getNextCheckDate(titleIssue) : "N/A"
            )}
          </Grid>
        )}
        {info?.dmvInfo?.titleImageUrl && (
          <Grid container xs={12}>
            <Grid xs={6} className={styles.label}>
              DMV Check Image
            </Grid>
            <Grid xs={6} className={styles.data}>
              <a
                href={info?.dmvInfo.titleImageUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                URL
              </a>
            </Grid>
          </Grid>
        )}
      </Grid>

      {titleIssue ? (
        <Grid container xs={12}>
          <Grid xs={6}>
            <Button variant="blue" onClick={openTitle}>
              View Full Details
            </Button>
          </Grid>
        </Grid>
      ) : null}
    </Paper>
  );
};

export default TitleInfo;

const statusStyles = {
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 18px",
    borderRadius: "16px",
    fontSize: "18px",
    fontWeight: 600,
    textTransform: "capitalize",
    whiteSpace: "nowrap",
  },
  statusUntitled: {
    backgroundColor: "#ffbb6c",
    color: "#fff",
  },
  statusTitled: {
    backgroundColor: "#10b981",
    color: "#fff",
  },
  statusNotChecked: {
    backgroundColor: "#f1f5f9",
    color: "#475569",
  },
};
